export enum CtaWrapperButtonSection {
  heroSection = 'heroSection',
  publisherSection = 'publisherSection',
  plansAndPricingSection = 'plansAndPricingSection',
}
